import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
interface SystemLoadingProps {
  message?: string;
  onComplete: () => void;
}
export function SystemLoading({
  message = 'Syncing your data...',
  onComplete
}: SystemLoadingProps) {
  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="flex flex-col items-center justify-center h-full w-full bg-stone-50 px-6 relative overflow-hidden" data-id="element-1175">
      <div className="relative z-10 flex flex-col items-center" data-id="element-1176">
        <div className="w-24 h-24 rounded-3xl overflow-hidden border-4 border-white shadow-md bg-stone-200 mb-6 relative" data-id="element-1177">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="https://cdn.magicpatterns.com/uploads/69mUG6ooMsKbP89Ta37mkt/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_bc3cfd10-111a-4766-8e76-81af2852edc8_2.mp4" data-id="element-1178" />
        </div>

        <div className="flex flex-col items-center space-y-4 text-center" data-id="element-1179">
          <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" data-id="element-1180" />
          <h2 className="text-xl font-extrabold text-slate-800 tracking-tight" data-id="element-1181">
            {message}
          </h2>
          <p className="text-slate-500 font-medium text-sm" data-id="element-1182">
            Just a moment while we get things ready.
          </p>
        </div>
      </div>
    </div>;
}